
    export var PACKAGE_VERSION = '3.0.0 (c86ba9a)';
    export var THEME = 'polaris';
    export var ALWAYS_VISUAL_REFRESH = false;
    